



















































import { Vue, Component, Prop } from 'vue-property-decorator'
import {
  WingBlank,
  MainHead,
  HeadTabs,
  CardItem,
  CardItemHead,
  DialogMain,
} from '@/components/index'
import { EnableList } from '@/api/ObectAdmin'
import {
  PlanDelate,
  PlanCategorylList,
  PlanCategorypage,
  PlanCategoryUpdata,
  PlanCategoryAdd,
} from '@/api/plainAdmin'

import { PlanUpdataFrom } from '@/types/PlanAdmin'
import { NBMessageBox } from '@/utils/nBMessageBox'
import Search from '../Search/inedx.vue'
@Component({
  components: {
    WingBlank,
    MainHead,
    HeadTabs,
    CardItem,
    CardItemHead,
    Search,
    DialogMain,
  },
})
export default class Main extends Vue {
  /**
   *
   * 头部信息
   *
   */

  headData: string[] = [
    '创建并维护各对象的运营计划，对满足运营计划的对象实例进行触达、更新等操作。',
    '在创建和维护运营计划前，请先选择对象。',
  ];
  headTitle: string = '计划看板';
  HeadImg: string = require('@/assets/images/u28.png');

  /**
   *
   * tab 头部切换
   *
   */
  tabsArr: any[] = [];
  tabsActive: number = 0;

  /**
   * search 搜索
   *运营计划状态名称及颜色
   *1：运行中（绿） 1
   *2：已结束（灰） 2
   *3：未开始（黄） 3
   *4：已停用（红） 4
   *  */
  statusArr: string[] = ['全部', '运行中', '已结束', '未开始', '已停用'];
  inputVal: string = '';
  statusActive: number = 0;

  /**
   *  card item头部信息
   */
  headTitleType = 'edit';
  headTitleTypeAdd = 'add';
  /**
   * card 数据,
   *
   * cardHead  card头部title整合
   * componentNumber 创建分组数量
   * [{...}]
   * title,
   *  status:
   *   *运营计划状态名称及颜色
   *    全部       ’‘ 不传
   *1：运行中 1
   *2：已结束 2
   *3：未开始 3
   *4：已停用 4
   * handle 触发方式
   * time 触发时间
   */
  componentNumber: number = 0;
  cardHead = [];
  cardArr: any = [];
  /**
   * dialogVisible 模态框
   */
  dialogVisible: boolean = false;
  dialogForm: PlanUpdataFrom = {
    name: '',
    id: null,
  };
  /**
   * 状态切换
   */
  handleClickStatus(idx: number, val: any) {
    this.statusActive = idx
    this.getAllList()
  }
  // 添加组件
  handleAdd(val: string) {
    const { tabsArr, tabsActive, statusActive } = this
    const data: PlanUpdataFrom = {
      name: val,
      objectId: tabsArr[tabsActive].id,
    }
    this.getCategoryAdd(data)
  }
  // 点击card 卡片
  handleItemCard(item: any) {
    const { tabsArr, tabsActive } = this
    this.$router.push({
      path: '/operate/detail',
      query: {
        id: item.id,
        objectName: tabsArr[tabsActive].name,
      },
    })
  }
  // 点击 card 头部删除
  // messagemox提示
  async handleHeadDel(id: number) {
    try {
      const { msg } = await NBMessageBox(this)
      await PlanDelate(id)
      this.getAllList()
      msg()
    } catch (e) {
      e.msg()
    }
  }
  // 点击 card 头部编辑
  handleHeadEdit(id: string | number, card: any) {
    this.dialogForm.name = card.name
    this.dialogForm.id = card.id
    this.dialogVisible = true
  }
  // 点击tab切换
  handlClickTabs(idx: number, item: any) {
    this.tabsActive = idx
    this.getAllList()
  }
  /**
   *
   *handleConfirm 模态框确认
   */
  async handleConfirm() {
    this.dialogVisible = false

    const { dialogForm, tabsArr, tabsActive } = this
    const params: PlanUpdataFrom = {
      ...dialogForm,
      objectId: tabsArr[tabsActive].id,
    }
    await PlanCategoryUpdata(params)
    this.geEnableList()
  }
  created() {
    this.geEnableList()
  }

  handleClose() {
    this.dialogVisible = false
  }
  /**
   * 头部tab信息获取
   */
  async geEnableList() {
    const { data } = await EnableList()
    this.tabsArr = data
    this.getAllList()
  }

  /**
   * 运营计划类别添加
   */
  async getCategoryAdd(params: PlanUpdataFrom) {
    const { data } = await PlanCategoryAdd(params)
    this.getAllList()
  }
  /**
   * 运营计划列表All 包含 运营计划类别列表和运营计划列表
   */

  async getAllList() {
    const { tabsArr, tabsActive, statusActive, inputVal } = this
    const _categoryList = {
      name: inputVal,
      objectId: tabsArr[tabsActive].id,
      status: statusActive === 0 ? '' : statusActive,
    }
    const planCategoryId = tabsArr[tabsActive].id
    const name = inputVal
    const _categorypage = {
      ..._categoryList,
      size: 1000,
      current: 0,
    }
    delete _categorypage.objectId
    // delete _categorypage.objectId
    const categorylist = await this.getCategoryList(_categoryList)
    const categoryPage: any = []
    for (let i = 0; i < categorylist.length; i++) {
      const data = (
        await this.getCategorypage(_categorypage, categorylist[i].id, name)
      ).records
      categoryPage.push(...data)
    }

    /**
     *
     * 数据整合处理
     *
     */

    const cardArr = []

    for (let i = 0; i < categorylist.length; i++) {
      const titleList = categorylist[i]
      const list = []
      for (let j = 0; j < categoryPage.length; j++) {
        const pageList = categoryPage[j]
        if (titleList.id === pageList.planCategoryId) {
          list.push(pageList)
        }
      }

      cardArr.push({
        ...titleList,
        list,
      })
    }
    this.cardHead = categorylist
    this.cardArr = cardArr
  }

  /**
   * 运营计划类别列表获取
   */
  async getCategoryList(params: any) {
    return (await PlanCategorylList(params)).data
  }
  /**
   * 运营计划类别列表获取
   */
  async getCategorypage(
    params: PlanUpdataFrom,
    planCategoryId: number,
    name: string
  ) {
    return (await PlanCategorypage(params, planCategoryId, name)).data
  }
}
